exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-desc-modal[data-v-6c40b26b] .ivu-table {\n  font-size: 13px;\n}\n.column-desc-modal[data-v-6c40b26b] .ivu-table-cell {\n  padding: 8px;\n}\n", ""]);

// exports
